module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/Placeholder-30502067191971869d25d00829f5d6aa.png";